import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 1.874c5.592 0 10.125 4.533 10.125 10.125S17.592 22.124 12 22.124 1.875 17.591 1.875 12 6.408 1.874 12 1.874zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zm4.412 3.85a.75.75 0 1 1 1.176.931l-6.527 8.258a1.624 1.624 0 0 1-2.632-.064L6.387 13.45a.75.75 0 1 1 1.226-.864L9.665 15.5c.022.034.06.054.1.055.04.002.078-.017.11-.06z' />
  </svg>
);
